import script from "./ViewTemplateBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTemplateBase.vue?vue&type=script&setup=true&lang=js"

import "./ViewTemplateBase.vue?vue&type=style&index=0&id=1c590bb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c590bb2"]])

export default __exports__